import React from "react";

export const HEXTooltipArrow = () => {
  return (
    <svg
      width="6"
      height="12"
      viewBox="0 0 6 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="c-hex-tooltip-arrow"
    >
      <path
        d="M6 0.5L0.32877 5.18518C-0.10959 5.54731 -0.10959 6.45266 0.32877 6.81482L6 11.5L6 0.5Z"
        fill="#007FC8"
      />
    </svg>
  );
};
